import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator, ValidatorFn } from '@angular/forms';
import { Directive, OnInit } from '@angular/core';
import * as moment from 'moment';
import { Moment } from 'moment';

export const reasonableBirthDateValidator = (): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }
    else {
      const momentValue: Moment = moment(control.value, 'YYYY-MM-DD');
      const now: Moment = moment();

      const difference: number = now.diff(momentValue, 'years');
      if (difference >= 125) {
        return { reasonableBirthdate: true };
      }
      else {
        return null;
      }
    }
  };
};

@Directive({
  selector: '[appReasonableBirthDate][formControlName],[appReasonableBirthDate][formControl],[appReasonableBirthDate][ngModel]',
  providers: [
      {
        provide: NG_VALIDATORS,
        useExisting: ReasonableBirthdateValidator,
        multi: true
      }
    ]
})
export class ReasonableBirthdateValidator implements Validator, OnInit {

  private validator: ValidatorFn;

  public ngOnInit():void {
    this.validator = reasonableBirthDateValidator();
  }

  public validate(control: AbstractControl): ValidationErrors | null {
    return this.validator(control);
  }
}
